import React from 'react';

import { Container, Selected } from './styles';

interface Props {
  optionValue?: string;
  value: any;
  handleChangeValue?: (value: any) => void;
  isChecked?: boolean;
  disabled?: boolean;
}

const RadioButton = ({ optionValue, value, handleChangeValue, isChecked, disabled }: Props) => {
  const selected = optionValue?.toLowerCase() === value.toLowerCase();

  return (
    <Container
      selected={selected}
      isChecked={isChecked}
      onClick={handleChangeValue ? () => handleChangeValue(value) : () => {}}
      disabled={disabled}
    >
      {(selected || isChecked) && <Selected disabled={disabled} />}
    </Container>
  );
};

export default RadioButton;
